import React from "react";
import Footer from "../../../Components/Footer/footer";

const EditPriceWatcher = () => {
  <Footer />;
};
export default EditPriceWatcher;
